import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Link from '../../../../components/link/Link';

const SignInLink = ({ disabled = false }: { disabled?: boolean }) => {
  const { t } = useTranslation();
  return (
    <Typography
      sx={{
        alignSelf: 'center',
        width: { xs: 'fit-content', lg: '100%' },
        fontSize: '14px',
      }}
    >
      {t('register.alreadyHaveAnAccount')}{' '}
      {disabled ? (
        t('register.signIn')
      ) : (
        <Link to="/login" color="secondary.main" sx={{ fontWeight: 'bold' }}>
          {t('register.signIn')}
        </Link>
      )}
    </Typography>
  );
};

export default SignInLink;
